import { Redirect } from "react-router-dom";

export const Logout = () => {
  console.log("Deslogando");
  sessionStorage.removeItem("tokenAuth");
  return <Redirect to={"/login"} />;
};

export default Logout;
